import graphql__35c8376a6a8a533047a1 from "./__generated__/RemoveContactDialog_contact.graphql.ts";
import graphql__ac1a7ad70fe2a6e5ae1e from "./__generated__/RemoveContactDialog_customerAccount.graphql.ts";
import graphql__49086e780857a907f5ef from "./__generated__/RemoveContactDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useIntl} from "react-intl";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";

type RemoveContactDialogProps = {
    contact: any,
    customerAccount: any,
    handleCloseDialog: () => {}
}

const RemoveContactDialog: React.FC<RemoveContactDialogProps> = (props) => {
    const intl = useIntl();
    const contact = useFragment(
        graphql__35c8376a6a8a533047a1,
        props.contact
    );

    const customerAccount = useFragment(
        graphql__ac1a7ad70fe2a6e5ae1e,
        props.customerAccount
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();
    
    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__49086e780857a907f5ef,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToRemoveContact'})
            }
        )
    }

    const initialValues = {
        customerAccountIdentifier: customerAccount.id,
        contactIdentifier: contact.id
    }

    const validationSchema = yup.object().shape({});

    const contactName = contact.teamName ?? (contact.givenName + " " + contact.familyName);

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog} handleSubmission={handleSubmission} initialValues={initialValues} validationSchema={validationSchema} headline={intl.formatMessage({id: 'dialog.RemoveContactDialog.headline'})} submitLabel={intl.formatMessage({id: 'dialog.RemoveContactDialog.submitLabel'})} dangerous>
            <Section>
                <Row>
                    <p>{intl.formatMessage({id: 'dialog.RemoveContactDialog.confirmMessage'}, {name: <strong>{contactName}</strong>, customer: <strong>{customerAccount.customerName}</strong>})}</p>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default RemoveContactDialog;
